export default "__VITE_ASSET__CDkAPlvu__"